// Tracks "last successful send per DCC software" in localStorage so the
// SendTo modal only opens on the first send within a rolling window. The
// window resets on a successful send, and on logout the whole map is wiped.

export const DCC_BRIDGE_LAST_SENT_AT_KEY = 'dccBridge:lastSentAt'
const FIRST_USE_WINDOW_MS = 30 * 24 * 60 * 60 * 1000

const readMap = () => {
  try {
    const raw = window.localStorage.getItem(DCC_BRIDGE_LAST_SENT_AT_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch (_) {
    return {}
  }
}

const writeMap = (map) => {
  try {
    window.localStorage.setItem(DCC_BRIDGE_LAST_SENT_AT_KEY, JSON.stringify(map))
  } catch (_) {
    // Storage may be unavailable (private mode, quota). Treat as no-op.
  }
}

export const isDccFirstUseFor = (name) => {
  if (!name) return true
  const map = readMap()
  const last = map[name]
  if (!last) return true
  const ageMs = Date.now() - new Date(last).getTime()
  return Number.isNaN(ageMs) || ageMs > FIRST_USE_WINDOW_MS
}

export const recordDccSendFor = (name) => {
  if (!name) return
  const map = readMap()
  map[name] = new Date(Date.now()).toISOString()
  writeMap(map)
}

export const clearDccBridgeFirstUse = () => {
  try {
    window.localStorage.removeItem(DCC_BRIDGE_LAST_SENT_AT_KEY)
  } catch (_) {
    // No-op.
  }
}
